import { BigNumber } from 'ethers';
import { SiloAsset } from 'queries/decoratedSilo';
import { createContext, Dispatch, SetStateAction, useContext } from 'react';
import { MaxAmount } from '../../../../hooks/useMaxTokenAmount';
import { UtilizationImpact } from '../../../../hooks/useUtilizationImpact';
import { Amount, ChecksumAddress } from '@silo/types';
import { LTV } from '../../../util/ltv';

export interface ActionFormContext {
  assetMenuAssets: SiloAsset[];
  selectedAddress: ChecksumAddress;
  setSelectedAddress: (selectedAddress: ChecksumAddress) => void;
  selectedAsset: SiloAsset;
  normalizedTokenAmount: BigNumber | null;
  setTokenAmount: Dispatch<SetStateAction<string>>;
  resetTokenAmount: () => void;
  isPending: boolean;
  maxAmount: MaxAmount;
  isFullAmount: boolean;
  utilizationImpact: UtilizationImpact;
  currentLTV: LTV | null;
  amount: Amount;
}

export const ActionFormContext = createContext<ActionFormContext>(null!);

export const useActionFormContext = () => useContext(ActionFormContext);
